module.exports = __webpack_public_path__ + "static/media/mail.b2fcb8c4.gif";